import React from 'react';
import { getAPIData, getAPIDataReturn } from '../utils/apiFunction';
import Autocomplete from '@mui/material/Autocomplete';
import SelectTextField from './SelectTextField';
import { greaterRank } from '../utils/roleFunctions';
import TextField from "@mui/material/TextField";
import { supplierToMatch } from '../utils/constants/warehouse'
import { hasWarehouseEditAccess } from "../pages/OysterPL8/utils/access";
import { Typography } from '@mui/material';


const SelectFarmWarehouse = (props) => {
    const [warehouse, setWarehouse] = React.useState([]);
    const [comboList, setComboList] = React.useState([]);
    const [value, setValue] = React.useState(props.state);
    const [cache, setCache] = React.useState(null);
    const [inputValue, setInputValue] = React.useState('');
    const [aocFarms, setAOCFarms] = React.useState([]);

    React.useEffect(() => {
        if (props.warehouseId && comboList) {
            var est = comboList.find((dr) => { return (dr.warehouseId === props.warehouseId) });
            setValue(est);
        }
    }, [comboList, props.warehouseId])
    React.useEffect(() => {
        if (!props.notFirstOne) {
            if (!props.warehouseId) {
                updateStates(comboList[0]);
            }
        }
    }, [comboList])

    React.useEffect(() => {
        getAOCWarehouses(props.access, props.showAll, setComboList, props.sortToTop, props.filterWarehouse);
    }, []);

    const updateStates = (val) => {
        if (val) {
            setValue(val);
            props.setState(val);
            if (props.hasEditAccess) {
                props.hasEditAccess(hasWarehouseEditAccess(props.access, val.id, comboList))
            }
        }
    }

    if ((comboList.length == 1) && (value)) {
        return <Typography variant="h4" fontWeight={400} sx={{ paddingLeft: '5px' }} >{value.displayName}</Typography>
    } else {
        return (

            <SelectTextField style={props.normal ? {} : { minWidth: '250px' }} checkID={value?.id} title={props.title ? props.title : "Farm"} state={value} setState={(val) => { updateStates(val) }} list={comboList} nameFunc={(op) => { return op.displayName }} disabled={props.disabled} />
        );
    }



}
export default SelectFarmWarehouse;

export const getAOCWarehouses = async (access, showAll, setFunc, sortToTop, filterWarehouse) => {
    var res = await getAPIDataReturn('/Farms/GetWarehouses');
    var warehouse = res.sort((a, b) => {
        return a.description > b.description ? 1 : -1;
    });
    var newCombo = []
    if (!showAll) {
        if ((warehouse.length > 0)) {
            for (var i = 0; i < warehouse.length; i++) {
                if (access?.find((a) => { return a.key.toLowerCase() === warehouse[i]?.accessName?.toLowerCase() })) {
                    newCombo.push(warehouse[i])
                }
            }
        }
    } else {
        newCombo = (warehouse);
    }

    if (typeof filterWarehouse === 'function') {
        newCombo = newCombo.filter((w) => filterWarehouse(w));
    }

    newCombo = newCombo.sort((a, b) => {
        var aAcc = access?.find((acc) => { return acc.key === a?.accessName });
        var bAcc = access?.find((acc) => { return acc.key === b?.accessName });
        console.log(a.description, aAcc?.value, b.description, bAcc?.value)
        if (aAcc && bAcc) {
            return greaterRank(aAcc.value, bAcc.value) ? -1 : 1;
        } else if (aAcc) {
            return -1;
        } else if (bAcc) {
            return 1;
        } else {
            return 1;
        }
    });
    
    setFunc(newCombo.map((w) => { return { ...w, warehouseId: w.id } }));
}